<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/institution-list">会员风采</router-link></li>
                <li class="currentNode"><a>驻京办风采</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>会员风采</a></li>
                    <li><router-link to="/layout/institution-list" class="active">驻京办风采</router-link></li>
                    <li><router-link to="/layout/company-list">企业风采</router-link></li>
                    <!-- <li><router-link to="/layout/city-food">驻京美食</router-link></li> -->
                    <li><router-link to="/layout/good-product-list">名特优产品</router-link></li>
                    <li><router-link to="/layout/cultural-heritage-list">非物质文化遗产</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>驻京办风采</h3>
                    <ul class="office-ul">
                        <li class="office-item" @click="goDetail(office)" v-for="office in officeList" :key="office.Id">
                            <img :src="office.ImageUrl" />
                            <p>{{ office.Title }}</p>
                        </li>
                        <!-- <li class="office-item">
                            <img src="@/assets/image/index/office2.png"/>
                            <p>山东省人民政府驻北京办事处</p>
                        </li>
                        <li class="office-item">
                            <img src="@/assets/image/index/office3.png"/>
                            <p>河北省人民政府驻北京办事处</p>
                        </li>
                        <li class="office-item">
                            <img src="@/assets/image/index/office4.png"/>
                            <p>河南省人民政府驻北京办事处</p>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getZhujingbanList
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            officeList: [],
            total: 0,
            currentPage: 1,
            pageSize: 12,
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.getZhujingbanList();
    },
    methods: {
        getZhujingbanList() {
            getZhujingbanList({current: this.currentPage, size: this.pageSize}).then(res => {
                if (res.Code == 1 && res.Data.length!==0) {
                    this.officeList = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.$message.error("驻京办风采请求失败");
                }
            })
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/institution-detail',
                query: {
                    id: data.Id,
                    page: this.currentPage,
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getZhujingbanList();
        }
    }
}
</script>

<style scoped>
/* .page-main{
    display: block;
    background: #fff;
    padding: 30px 30px;
    box-sizing: border-box;
} */
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.office-ul{
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;;
    align-items: center;
    flex-wrap: wrap;
}
.office-item{
    width: 305px;
    height:160px;
    margin-bottom: 20px;
    margin-right: 20px;
    position: relative;
}
.office-item img {
    width: 305px;
    height:160px;
}
.office-ul .office-item:nth-child(3n) {
    margin-right:0;
}
.office-item::before {
    content: "";
    width: 100%;
    height: 50px;
    background: linear-gradient(360deg, #000000 -5.09%, rgba(0, 0, 0, 0) 99.31%);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 5;
    transition: all .36s;
    cursor: pointer;
}
.office-item:hover {
    box-shadow: 0px 4px 7.3px 0px #00000040;
}
.office-item:hover::before {
    height: 160px;
}
.office-item:hover p {
    top: 60px;
}

.office-item p {
    font-family: 思源黑体 CN;
    font-size: 18px;
    text-align: center;
    color: #fff;
    position: absolute;
    width:100%;
    top: 100px;
    left:0;
    z-index: 10;
    transition: all .36s;
    cursor: pointer;
}
</style>